module.exports = __webpack_public_path__ + "img/add_invoice_attach.7226f4d9.svg";